import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";

import { FormUtils as GetAllFormFields } from 'sz-react-utils'

import moment from "moment";
import { Button, Card, notification, Row, Col, Form, Tabs, Popover } from "antd";
import _ from "lodash";
import Request, { API_URL } from "../../request";
import { connect } from "react-redux";
import { HiInformationCircle } from "react-icons/hi";

const TabPane = Tabs.TabPane


@Form.create()
class PayrollSettings extends React.Component {
  state = {
    count: 0,
    activeTab: '0',
    uniArr: [],
    countries: [],
    countryArray: [],
    courseUniversityIds: {},
    courseUniversityIdsJson: {},
    countriesData: [],
    countryids: [],
    checkCountrySetup: false,
    checkUniversitySetup: false,
    trackUserAttendence: true,
    loadResponse: true,
    deductEpfEsic: false,
    phoneCodes: [],
    buttonLoading: [],
    paymentMethods: [],
    paymentOptions: [],
    btnClass: {
      'Save': '#0eb8f7',
      'Update': '#0a8f65',
      'Processing': '#d8cb15',
      'Completed': '#19d815'
    },
    dateFormates: [
      'DD/MM/YYYY', 'MM/dd/yyyy', 'dd.MM.yyyy', 'DD.MM.YYYY', 'DD-MM-YYYY', 'MM-dd-YYYY', 'YYYY.MM.DD', 'DD-MMM-YYYY', 'YYYY-MM-DD'
    ],
    companySettingObject: {}
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    moment('2024-10-08T08:09:06.103+00:00').format('HH:mm:ss')
    let activeUser = JSON.parse(localStorage.getItem('user'))
    this.setState({ activeUser })
    let companySettingObject = await Request.getBusinessDetails(activeUser.businessId);
    if (companySettingObject.selectPaymentMethods) {
      this.setState({ selectPaymentMethods: companySettingObject.selectPaymentMethods })
    }
    this.props.form.setFieldsValue(companySettingObject)

    this.setState({ companySettingObject });

    let response = await Request.getCountriesWithoutBusinessAuth({
      results: 10000,
      count: 10000
    });
    if (response && !response.error) {
      let countries = []
      let countryArray = [];
      let buttonLoading = [];
      let phoneCodes = [];
      _.each(response.data, (country) => {
        countries.push({
          _id: country._id,
          countryName: country.countryName,
          display: country.countryName
        })
        phoneCodes.push({ key: country.countryPhoneCode, id: country.countryPhoneCode, display: country.countryPhoneCode });
        countryArray[country._id] = country.countryName;
        buttonLoading[country._id] = 'Save';
      })
      this.setState({ countries, countryArray, buttonLoading, phoneCodes })
    }
  }

  callback = (value) => {
    this.setState({ activeTab: value })
    if (value) {
      let companySettingObject = this.state.companySettingObject;
      if (value == '0') {
        if (companySettingObject.sandwichAllowedPerYear) {
          this.setState({ sandwichAllowedPerYear: companySettingObject.sandwichAllowedPerYear })
        }
        if (companySettingObject.trackAllUserAttendence) {
          this.setState({ trackUserAttendence: companySettingObject.trackAllUserAttendence })
        }
        setTimeout(() => {
          this.props.form.setFieldsValue(companySettingObject)
        }, 500)

      } else if (value == '1') {
        if (companySettingObject.deductSalaryWorkFromHome) {
          this.setState({ deductSalaryWorkFromHome: companySettingObject.deductSalaryWorkFromHome })
        }
        if (companySettingObject.deductSalaryLeaveWithoutNotice) {
          this.setState({ deductSalaryLeaveWithoutNotice: companySettingObject.deductSalaryLeaveWithoutNotice })
        }
        if (companySettingObject.deductEpfEsic) {
          this.setState({ deductEpfEsic: companySettingObject.deductEpfEsic }, () => {
            this.props.form.setFieldsValue({
              ...companySettingObject,
              deductEpfEsic: companySettingObject.deductEpfEsic,
              maxSalaryForEPF: companySettingObject.maxSalaryForEPF,
              epfPercentage: companySettingObject.epfPercentage,
              esicPercentage: companySettingObject.esicPercentage,

            })
          })
        }
        setTimeout(() => {
          this.props.form.setFieldsValue(companySettingObject)
        }, 500)
      }
    }
  }


  handleSubmit = async (e) => {
    const { form, dispatch } = this.props
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      const values = _.clone(valData)
      values.businessId = this.state.activeUser.businessId;
      if (this.state.paymentMethods.length) {
        values.paymentMethods = this.state.paymentMethods;
      }
      if (this.state.paymentOptions.length) {
        values.paymentOptions = this.state.paymentOptions;
      }
      let response = await Request.addUpdateCompanySetting(values)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          messsage: response.message
        })
      }
    })
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
    } = this.props;

    const { deductSalaryLeaveWithoutNotice, deductSalaryWorkFromHome,
      sandwichAllowedPerYear, trackUserAttendence, deductEpfEsic } = this.state
    const content = <div>
      <h4>Track all your User's Attendance?</h4>
      <p>This feature helps in calculating staff salaries by tracking their work hours using TVision.<br /> It calculates hours worked based on total work days and salary.</p>
      <br />
      <h4>Auto-Logout from CRM when Shift-Ends?</h4>
      <p>This feature will disable the time count of the worked hours after the shit timings.<br /> This will help in streamlining your staff’s punctuality to work.</p>
      <br />
      <h4>Seek permission to work after Shift hours before allowing to use T-Vision?</h4>
      <p>Staff must seek permission to work after shift hours using T-Vision.<br />They need approval for any overtime worked.</p>
      <br />
      <h4>Seek comments/clarification for Late Log-in and Early Log-out?</h4>
      <p>If your staff start’s their shift later or ends early than their allotted time,<br /> it will ask for the reason before starting/stopping their timer.</p>
      <br />
      <h4>Remind the user before User's Shift Ends?</h4>
      <p>Sends reminders to staff before their shift ends, aiding in timely work completion.</p>
      <br />
      <h4>Do you have Head of Departments?</h4>
      <p>If you have head of departments to whom their subordinates or team members report<br /> to and  take various permissions for leaves, appraisals, and resignations. Turning it ‘off’<br />  will automaticallydirect all these requests to the admin.</p>
      <br />
      <h4>How many sandwich leaves are allowed per year?</h4>
      <p>Sets the number of sandwich leaves allowed per year, assisting in salary calculation.</p>
    </div>

    let salaryInputTypes = {
      fields: [
        {
          label: 'Deduct the salary of employees who are working from home?',
          key: 'deductSalaryWorkFromHome',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              deductSalaryWorkFromHome: v
            })
            this.setState({ deductSalaryWorkFromHome: v })
          }
        },
        {
          label: 'Amount in %',
          key: 'amountInPercentageForWorkFromHome',
          type: 'number',
          hidden: !deductSalaryWorkFromHome,
          required: deductSalaryWorkFromHome
        },
        {
          label: 'Deduct the salary of employees who take leave without notice?',
          key: 'deductSalaryLeaveWithoutNotice',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              deductSalaryLeaveWithoutNotice: v
            })
            this.setState({ deductSalaryLeaveWithoutNotice: v })
          }
        },
        {
          label: 'Amount in %',
          key: 'amountInPercentageForLeaveWithoutNotice',
          type: 'number',
          hidden: !deductSalaryLeaveWithoutNotice,
          required: deductSalaryLeaveWithoutNotice
        },
        {
          label: 'Providing EPF & ESIC Service?',
          key: 'deductEpfEsic',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              deductEpfEsic: v
            })
            this.setState({ deductEpfEsic: v })
          }
        },
        {
          label: 'Maximum Salary Amount EPF',
          key: 'maxSalaryForEPF',
          type: 'number',
          hidden: !deductEpfEsic,
          required: deductEpfEsic
        },
        {
          label: 'Maximum Salary Amount ESIC',
          key: 'maxSalaryForESIC',
          type: 'number',
          hidden: !deductEpfEsic,
          required: deductEpfEsic
        },
        {
          label: 'EPF Percentage',
          key: 'epfPercentage',
          type: 'number',
          hidden: !deductEpfEsic,
          required: deductEpfEsic
        },
        {
          label: 'ESIC Percentage',
          key: 'esicPercentage',
          prefixComp: 'Enter Decimal Value',
          type: 'text',
          hidden: !deductEpfEsic,
          required: deductEpfEsic
        },
        {
          label: 'Counsellor Incentive on Registration',
          key: 'counsellorIncentiveOnRegistration',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              counsellorIncentiveOnRegistration: v
            })
            this.setState({ counsellorIncentiveOnRegistration: v })
          }
        },
        {
          label: 'Visitor Visa Incentive ?',
          key: 'visitorVisaIncentive',
          type: 'switch',
          onChange: v => {
            setFieldsValue({ visitorVisaIncentive: v });
          }
        },
        {
          label: 'Visitor Visa Incentive Mode',
          key: 'visitorVisaIncentiveMode',
          type: 'select',
          hidden: !getFieldValue('visitorVisaIncentive'),
          required: getFieldValue('visitorVisaIncentive'),
          options: ['Combined', 'Individual'],
          onChange: v => {
            setFieldsValue({ visitorVisaIncentiveMode: v });
          }
        },
        {
          label: 'Visitor Visa Target Amount',
          key: 'visitorVisaTargetAmount',
          type: 'number',
          hidden: getFieldValue('visitorVisaIncentiveMode') !== 'Combined' || !getFieldValue('visitorVisaIncentive'),
          required: getFieldValue('visitorVisaIncentiveMode') === 'Combined' && getFieldValue('visitorVisaIncentive'),
        },
        {
          label: 'Visitor Visa Incentive Type',
          key: 'visitorVisaIncentiveType',
          type: 'select',
          hidden: getFieldValue('visitorVisaIncentiveMode') !== 'Combined',
          required: getFieldValue('visitorVisaIncentiveMode') === 'Combined',
          options: ['Fixed', 'Percentage'],
          onChange: v => {
            setFieldsValue({ visitorVisaIncentiveType: v });
          }
        },
        {
          label: getFieldValue('visitorVisaIncentiveType') === 'Fixed' ? 'Fixed Amount' : 'Percentage',
          key: 'visitorVisaIncentiveAmount',
          type: 'number',
          hidden: getFieldValue('visitorVisaIncentiveMode') !== 'Combined' || !getFieldValue('visitorVisaIncentiveType'),
          required: getFieldValue('visitorVisaIncentiveMode') === 'Combined' && getFieldValue('visitorVisaIncentiveType'),
        },
      ]
    }

    let attendanceInputTypes = {
      fields: [
        {
          label: `Track all your User\'s Attendance?`,
          key: 'trackAllUserAttendence',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              trackAllUserAttendence: v
            })
            this.setState({ trackUserAttendence: v })
          }
        },
        {
          label: 'Auto-Logout from CRM when Shift-Ends?',
          key: 'autoLogoutCrm',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              autoLogoutCrm: v
            })
          }
        },
        // {
        //   label:'Grace Period Minutes',
        //   type:'number',
        //   key:'attendanceGracePeriodMinutes',
        // },
        // {
        //   label:'How Many Times Grace Period Applies in Month?',
        //   type:'number',
        //   key:'numberOfGraceApplied'
        // },
        {
          label: 'Standard Working Hours',
          type: 'number',
          key: 'standardWorkingHours',
        },
        {
          label: 'Paid Leaves Per Month?',
          type: 'number',
          key: 'paidLeavesPerMonth',
        },
        {
          label: 'Paid Leave After (in Months)',
          type: 'number',
          key: 'paidLeavesAfterMonth',
        },
        {
          label: 'Seek permission to work after Shift hours before allowing to use T-Vision?',
          key: 'workAfterShiftHours',
          type: 'switch',
          hidden: !trackUserAttendence,
          onChange: v => {
            setFieldsValue({
              workAfterShiftHours: v
            })
          }
        },
        {
          label: 'Seek comments/clarification for Late Log-in and Early Log-out?',
          key: 'promptForEarlyLoginLogout',
          type: 'switch',
          hidden: !trackUserAttendence,
          onChange: v => {
            setFieldsValue({
              promptForEarlyLoginLogout: v
            })
          }
        },
        {
          label: 'Remind the user before User\'s Shift Ends?',
          key: 'remindBeforeShiftEnd',
          type: 'switch',
          hidden: !trackUserAttendence,
          onChange: v => {
            setFieldsValue({
              remindBeforeShiftEnd: v
            })
          }
        },
        {
          label: 'Do you have Head of Departments?',
          key: 'haveHeadOfDepartments',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              haveHeadOfDepartments: v
            })
          }
        },

        {
          label: 'How many sandwich leaves are allowed per year?',
          key: 'sandwichAllowedPerYear',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              sandwichAllowedPerYear: v
            })
            this.setState({ sandwichAllowedPerYear: v })
          }
        },
        {
          label: 'Number of leaves allowed',
          key: 'numberOfSandwichLeaves',
          type: 'number',
          hidden: !sandwichAllowedPerYear,
          required: sandwichAllowedPerYear
        },
        {
          label: 'Phone Submission Notification (comma separated email Ids)',
          key: 'phoneSubmissionNotification',
        }
      ]
    }

    return (
      <PageHeaderWrapper title={"Payroll Settings"}>

        <Card style={{ marginBottom: 10 }}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`Attendance`} key={'0'}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <Card>
                  <Row>
                    <Col span={24}>
                      <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <Popover style={{ width: '10px' }} content={content}><HiInformationCircle style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: '#ffb703' }} /></Popover>
                      </div>
                      <GetAllFormFields
                        apiurl={API_URL}
                        inputSchema={attendanceInputTypes}
                        refresh={this.refreshFxn}
                        loading={this.props.loading}
                        getFieldDecorator={getFieldDecorator}
                      />
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginBottom: 10 }}
                        loading={this.props.loading}>
                        SAVE
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Form>
            </TabPane>
            <TabPane tab={`Salaries`} key={'1'}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <Card>
                  <Row>
                    <Col span={24}>
                      <GetAllFormFields
                        apiurl={API_URL}
                        inputSchema={salaryInputTypes}
                        refresh={this.refreshFxn}
                        loading={this.props.loading}
                        getFieldDecorator={getFieldDecorator}
                      />
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginBottom: 10 }}
                        loading={this.props.loading}>
                        SAVE
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Form>
            </TabPane>

          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayrollSettings);
